/**
 * An array of steps for a guided tour.
 * Each step contains a selector and content to display for that step.
 *
 * @type {Array<{ selector: string, content: string }>}
 */
export const steps = [
  // 1st Step 
  {
    selector: '.first-step',
    content: 'Total number of respondents, questions, and drop down menu to select questions',
  },
  // 2nd Step 
  {
    selector: '.second-step',
    content: 'Dynamic Bar Chart that lets you see responses by grouping using the drop down menu',
  },
  // 4th Step 
  {
    selector: '.forth-step',
    content: 'Filter menu to filter the data',
  }
];
